import React from "react";

/**
 * Immutable platform attribution. Always shows "Powered by DyNamic Tax",
 * regardless of any admin's white-label choices.
 */
export default function PoweredBy({ className = "", inverse = false }) {
  const base = inverse
    ? "text-primary-foreground/60 hover:text-primary-foreground/80"
    : "text-muted-foreground/70 hover:text-muted-foreground";
  return (
    <div className={`text-[10px] tracking-[0.25em] uppercase ${base} transition-colors ${className}`} data-testid="powered-by">
      Powered by{" "}
      <span className="font-serif normal-case tracking-normal text-xs italic">DyNamic Tax</span>
    </div>
  );
}
